import React, { useEffect } from 'react';
type MetaPixelFunction = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: (...args: unknown[]) => void;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixelFunction;
    _fbq?: MetaPixelFunction;
  }
}
const PIXEL_ID = '1111855051790470';
export function MetaPixel() {
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }
    const fbq = ((...args: unknown[]) => {
      if (fbq.callMethod) {
        fbq.callMethod(...args);
      } else {
        fbq.queue?.push(args);
      }
    }) as MetaPixelFunction;
    window.fbq = fbq;
    if (!window._fbq) {
      window._fbq = fbq;
    }
    fbq.queue = [];
    fbq.loaded = true;
    fbq.version = '2.0';
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    fbq('init', PIXEL_ID);
    fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-118" data-mp="18hl20cyj7tat">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-119" data-mp="13gx3z7bvyc73" />
    </noscript>;
}